import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { SignInRoutingModule } from './sign-in-routing.module';
import { SignInComponent } from './sign-in.component';

@NgModule({
  declarations: [SignInComponent],
  imports: [
    SignInRoutingModule,
    SharedModule.forRoot(),
  ],
  exports: [SignInComponent],
  providers: [],
})
export class SignInModule { }
